import type { ReactNode } from "react";
import { Container } from "@/components/site/Container";

export type SectionTone = "light" | "mist" | "navy";

type SectionProps = {
  children: ReactNode;
  /** Visual role of the band: white, mist or deep navy. */
  tone?: SectionTone;
  /** Compact bands use half the vertical rhythm. */
  compact?: boolean;
  /** Render without the inner grid container. */
  bleed?: boolean;
  id?: string;
  className?: string;
};

const toneClass: Record<SectionTone, string> = {
  light: "bg-background text-foreground",
  mist: "bg-surface text-foreground",
  navy: "bg-primary text-primary-foreground",
};

export function Section({
  children,
  tone = "light",
  compact = false,
  bleed = false,
  id,
  className = "",
}: SectionProps) {
  const rhythm = compact ? "py-10 lg:py-16" : "py-16 lg:py-30";
  return (
    <section id={id} className={`${toneClass[tone]} ${rhythm} ${className}`}>
      {bleed ? children : <Container>{children}</Container>}
    </section>
  );
}
